import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f599zctqct: FaireBrandEntity = {
  token: "b_f599zctqct",
  type: "brand",
  name: "Bo & Mei",
  avatarUrl:
    "https://cdn.faire.com/fastly/bd5b71b76cd65080c589d1a5408762d0b66a6ce2a4212ff690cafff812e7e918.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/49cc5d280fd3d7f9024d0d32f03b3b3132b93019add703b833628bf00e371fde.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/bd5b71b76cd65080c589d1a5408762d0b66a6ce2a4212ff690cafff812e7e918.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/49cc5d280fd3d7f9024d0d32f03b3b3132b93019add703b833628bf00e371fde.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Where Play Meets Culture\n\nAt Bo & Mei, we design modern puzzles, games, and creative activities that bring families together through play and cultural discovery.\n\nFounded by a mom of two who wanted her children to grow up proud of their roots and curious about the world, Bo & Mei was created to make cultural learning hands-on, joyful, and meaningful. From Lunar New Year crafts to storybook-inspired puzzles and our signature family mahjong set, each product invites intergenerational play and celebrates the beauty of diverse traditions.\n\nOur mission is simple: to nurture cultural pride and empathy through the power of creative play—one story, one puzzle, one family moment at a time.\n\nBased in New York | Women- and Asian-owned | Thoughtfully designed for modern families",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:34.289Z",
    importedBy: "entity-db-cli",
  },
};
